<script setup lang="ts">
import { SwiperSlide } from 'swiper/vue';
import type { Swiper as SwiperClass } from 'swiper';

import { sliderSettings } from '~/components/homepage/services/components/servicesSlider/constants/sliderOptions';
import { servicesList } from '~/components/homepage/services/components/servicesSlider/constants/servicesList';
import UiSlider from '~/components/ui/UiSlider/component/UiSlider.vue';
import ServicesCard from '~/components/homepage/services/components/servicesCard/ServicesCard.vue';

const activeIndex = ref(0);
const swiperInstance = ref<SwiperClass | null>(null);
const hoveredIndex = ref<number | null>(null);

const onSwiperInit = (swiper: SwiperClass) => {
    swiperInstance.value = swiper;
    activeIndex.value = swiper.realIndex;
};

const onSlideChange = (swiper: SwiperClass) => {
    activeIndex.value = swiper.realIndex;
};

const onCardClick = (index: number) => {
    if (!swiperInstance.value) {
        return;
    }

    swiperInstance.value.slideToLoop(index);
};

const isActiveCard = (index: number) => {
    return hoveredIndex.value === index || activeIndex.value === index;
};
</script>

<template>
    <UiSlider
        :swiper-options="sliderSettings"
        class="services__slider services-slider"
        @swiper="onSwiperInit"
        @slideChange="onSlideChange"
    >
        <SwiperSlide
            v-for="(slide, index) in servicesList"
            :key="`services-slider-slide-${index}`"
            class="services-slider__slide"
        >
            <ServicesCard
                :slide="slide"
                :is-active="isActiveCard(index)"
                @mouseenter="hoveredIndex = index"
                @mouseleave="hoveredIndex = null"
                @click="onCardClick(index)"
            />
        </SwiperSlide>
    </UiSlider>
</template>
